(() => {
  const pdhHeader = document.getElementById('pdh-header');
  const pdhMenuToggle = document.getElementById('pdh-menu-toggle');
  const pdhNav = document.getElementById('pdh-nav');
  const pdhHero = document.getElementById('pdh-hero');
  const pdhFloat = document.querySelector('.pdh-whatsapp-float');

  const pdhOnScroll = () => {
    const pdhY = window.scrollY;
    if (pdhHeader) {
      pdhHeader.classList.toggle('pdh-compact', pdhY > 30);
      const pdhMax = document.documentElement.scrollHeight - window.innerHeight;
      pdhHeader.style.setProperty('--pdh-progress', (pdhMax > 0 ? Math.min(100, pdhY / pdhMax * 100) : 0) + '%');
    }
    if (pdhFloat && pdhHero) {
      pdhFloat.classList.toggle('pdh-show', pdhY > pdhHero.offsetHeight * 0.75);
    }
  };
  pdhOnScroll();
  window.addEventListener('scroll', pdhOnScroll, {passive:true});

  const pdhCloseMenu = () => {
    if (!pdhNav || !pdhMenuToggle) return;
    pdhNav.classList.remove('pdh-open');
    pdhMenuToggle.setAttribute('aria-expanded', 'false');
    pdhMenuToggle.setAttribute('aria-label', 'Abrir menú');
  };

  if (pdhMenuToggle && pdhNav) {
    pdhMenuToggle.addEventListener('click', () => {
      const pdhOpen = pdhNav.classList.toggle('pdh-open');
      pdhMenuToggle.setAttribute('aria-expanded', String(pdhOpen));
      pdhMenuToggle.setAttribute('aria-label', pdhOpen ? 'Cerrar menú' : 'Abrir menú');
    });
    pdhNav.querySelectorAll('a').forEach((pdhLink) => pdhLink.addEventListener('click', pdhCloseMenu));
    document.addEventListener('keydown', (pdhE) => { if (pdhE.key === 'Escape') pdhCloseMenu(); });
  }

  const pdhSpyLinks = document.querySelectorAll('[data-pdh-spy]');
  if (pdhSpyLinks.length && 'IntersectionObserver' in window) {
    const pdhSpy = new IntersectionObserver((pdhEntries) => {
      pdhEntries.forEach((pdhEntry) => {
        if (!pdhEntry.isIntersecting) return;
        pdhSpyLinks.forEach((pdhL) => pdhL.setAttribute('aria-current', String(pdhL.dataset.pdhSpy === pdhEntry.target.id)));
      });
    }, {rootMargin:'-45% 0px -50% 0px'});
    pdhSpyLinks.forEach((pdhL) => { const pdhT = document.getElementById(pdhL.dataset.pdhSpy); if (pdhT) pdhSpy.observe(pdhT); });
    if (pdhHero) {
      new IntersectionObserver((pdhEntries) => {
        pdhEntries.forEach((pdhEntry) => { if (pdhEntry.isIntersecting) pdhSpyLinks.forEach((pdhL) => pdhL.setAttribute('aria-current', 'false')); });
      }, {rootMargin:'-45% 0px -50% 0px'}).observe(pdhHero);
    }
  }

  if (document.getElementById('pdh-tab-presenciales')) {
  const pdhTabPres = document.getElementById('pdh-tab-presenciales');
  const pdhTabDist = document.getElementById('pdh-tab-distancia');
  const pdhPanelPres = document.getElementById('pdh-panel-presenciales');
  const pdhPanelDist = document.getElementById('pdh-panel-distancia');

  const pdhShowTab = (pdhWhich) => {
    const pdhPres = pdhWhich === 'presenciales';
    pdhTabPres.setAttribute('aria-selected', String(pdhPres));
    pdhTabDist.setAttribute('aria-selected', String(!pdhPres));
    pdhTabPres.tabIndex = pdhPres ? 0 : -1;
    pdhTabDist.tabIndex = pdhPres ? -1 : 0;
    pdhPanelPres.hidden = !pdhPres;
    pdhPanelDist.hidden = pdhPres;
    pdhAnimateRows(pdhPres ? pdhPanelPres : pdhPanelDist);
  };

  pdhTabPres.addEventListener('click', () => pdhShowTab('presenciales'));
  pdhTabDist.addEventListener('click', () => pdhShowTab('distancia'));
  [pdhTabPres, pdhTabDist].forEach((pdhTab) => pdhTab.addEventListener('keydown', (pdhE) => {
    if (pdhE.key !== 'ArrowRight' && pdhE.key !== 'ArrowLeft') return;
    const pdhNext = pdhTab === pdhTabPres ? pdhTabDist : pdhTabPres;
    pdhShowTab(pdhNext === pdhTabPres ? 'presenciales' : 'distancia');
    pdhNext.focus();
  }));

  const pdhObserver = new IntersectionObserver((pdhEntries, pdhObs) => {
    pdhEntries.forEach((pdhEntry) => {
      if (pdhEntry.isIntersecting) {
        pdhEntry.target.classList.add('pdh-visible');
        pdhObs.unobserve(pdhEntry.target);
      }
    });
  }, {threshold:.12});

  function pdhAnimateRows(pdhPanel) {
    pdhPanel.querySelectorAll('.pdh-course-row').forEach((pdhRow, pdhIndex) => {
      pdhRow.style.transitionDelay = `${pdhIndex * 70}ms`;
      pdhObserver.observe(pdhRow);
    });
  }

  pdhAnimateRows(pdhPanelPres);

  }

  const pdhReqSelect = document.getElementById('pdh-req-select');
  if (pdhReqSelect) {
    const pdhReqBtn = document.getElementById('pdh-req-btn');
    const pdhReqList = document.getElementById('pdh-req-list');
    const pdhReqOpts = Array.from(pdhReqList.querySelectorAll('.pdh-select-opt'));
    const pdhReqPanels = Array.from(document.querySelectorAll('.pdh-req-panel'));
    const pdhBtnVal = document.getElementById('pdh-req-btn-val');
    const pdhBtnMod = document.getElementById('pdh-req-btn-mod');
    let pdhActive = Math.max(0, pdhReqOpts.findIndex((pdhO) => pdhO.getAttribute('aria-selected') === 'true'));

    const pdhSetActive = (pdhI) => {
      pdhActive = (pdhI + pdhReqOpts.length) % pdhReqOpts.length;
      pdhReqOpts.forEach((pdhO, pdhJ) => pdhO.classList.toggle('pdh-active', pdhJ === pdhActive));
      pdhReqList.setAttribute('aria-activedescendant', pdhReqOpts[pdhActive].id);
      pdhReqOpts[pdhActive].scrollIntoView({block:'nearest'});
    };
    const pdhOpen = () => {
      pdhReqList.hidden = false;
      pdhReqBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => pdhReqSelect.classList.add('pdh-open'));
      pdhSetActive(pdhReqOpts.findIndex((pdhO) => pdhO.getAttribute('aria-selected') === 'true'));
      pdhReqList.focus();
    };
    const pdhClose = (pdhFocus) => {
      pdhReqSelect.classList.remove('pdh-open');
      pdhReqBtn.setAttribute('aria-expanded', 'false');
      pdhReqList.hidden = true;
      if (pdhFocus) pdhReqBtn.focus();
    };
    const pdhChoose = (pdhKey) => {
      const pdhOpt = pdhReqOpts.find((pdhO) => pdhO.dataset.key === pdhKey);
      if (!pdhOpt) return false;
      pdhReqOpts.forEach((pdhO) => pdhO.setAttribute('aria-selected', String(pdhO === pdhOpt)));
      pdhBtnVal.textContent = pdhOpt.querySelector('.pdh-opt-name').textContent;
      pdhBtnMod.textContent = pdhOpt.dataset.mod;
      pdhReqPanels.forEach((pdhP) => {
        const pdhShow = pdhP.dataset.req === pdhKey;
        pdhP.hidden = !pdhShow;
        if (pdhShow) { pdhP.classList.remove('pdh-in'); void pdhP.offsetWidth; pdhP.classList.add('pdh-in'); }
      });
      return true;
    };

    pdhReqBtn.addEventListener('click', () => (pdhReqList.hidden ? pdhOpen() : pdhClose(false)));
    pdhReqBtn.addEventListener('keydown', (pdhE) => {
      if (pdhE.key === 'ArrowDown' || pdhE.key === 'ArrowUp') { pdhE.preventDefault(); pdhOpen(); }
    });
    pdhReqOpts.forEach((pdhO) => {
      pdhO.addEventListener('click', () => { pdhChoose(pdhO.dataset.key); pdhClose(true); });
      pdhO.addEventListener('mousemove', () => pdhSetActive(pdhReqOpts.indexOf(pdhO)));
    });
    pdhReqList.addEventListener('keydown', (pdhE) => {
      if (pdhE.key === 'ArrowDown') { pdhE.preventDefault(); pdhSetActive(pdhActive + 1); }
      else if (pdhE.key === 'ArrowUp') { pdhE.preventDefault(); pdhSetActive(pdhActive - 1); }
      else if (pdhE.key === 'Home') { pdhE.preventDefault(); pdhSetActive(0); }
      else if (pdhE.key === 'End') { pdhE.preventDefault(); pdhSetActive(pdhReqOpts.length - 1); }
      else if (pdhE.key === 'Enter' || pdhE.key === ' ') { pdhE.preventDefault(); pdhChoose(pdhReqOpts[pdhActive].dataset.key); pdhClose(true); }
      else if (pdhE.key === 'Escape' || pdhE.key === 'Tab') { pdhClose(pdhE.key === 'Escape'); }
    });
    document.addEventListener('click', (pdhE) => { if (!pdhReqSelect.contains(pdhE.target) && !pdhReqList.hidden) pdhClose(false); });

    document.querySelectorAll('[data-course]').forEach((pdhButton) => {
      pdhButton.addEventListener('click', () => {
        if (!pdhChoose(pdhButton.dataset.course)) return;
        document.getElementById('pdh-requisitos').scrollIntoView({behavior:'smooth'});
      });
    });
  }
})();
